module.exports = __webpack_public_path__ + "static/media/Scan 9.b285ec6a.jpeg";